const Login = () => import('@view/Login/index.vue');
const NotFound = () => import('@cmp/404/index.vue')
const ViewPort = () => import('@view/Viewport/index.vue')
const Index = () => import('@view/Index/index.vue')
const AllNum = () => import('@view/AllNum/index.vue')
const ActiveNum = () => import('@view/ActiveNum/index.vue')
const SuccessNum = () => import('@view/SuccessNum/index.vue')
const BadNum = () => import('@view/BadNum/index.vue')
const AddNum = () => import( "@/view/AddNum/index.vue")
const AddCard = () => import( "@/view/AddCard/index.vue")
const BillingList = () => import('@view/BillingList/index.vue')

const AddNumTelegram = () => import( "@/view/telegram/AddNum/index.vue")

export default [
    {
        path: '/',
        redirect: '/viewPort'
    },
    {
        path: '/login',
        component: Login,
        name: 'Login',

    },
   
    {
        path: '/viewPort',
        component: ViewPort,
        name: 'ViewPort',
        redirect:'/viewPort/index',
        children: [
            {
                path: '/viewPort/index',
                component: Index,
                name: 'Index',
                meta:{
                    isJudge:true
                }
            },
            {
                path: '/viewPort/allNum',
                component: AllNum,
                name: 'AllNum',
                meta:{
                    isJudge:true
                }
            },
            {
                path: '/viewPort/activeNum',
                component: ActiveNum,
                name: 'ActiveNum',
                meta:{
                    isJudge:true
                }
            },
            {
                path: '/viewPort/successNum',
                component: SuccessNum,
                name: 'SuccessNum',
                meta:{
                    isJudge:true
                }
            },
            {
                path: '/viewPort/badNum',
                component: BadNum,
                name: 'BadNum',
                meta:{
                    isJudge:true
                }
            },
            {
                path: '/viewPort/billingList',
                component: BillingList,
                name: 'BillingList',
                meta:{
                    isJudge:true
                }
            },
            {
                path: '/viewPort/AddNum',
                component: AddNum,
                name: 'AddNum',
                meta:{
                    isJudge:true
                }
            },
            {
                path: '/viewPort/telegram/AddNum',
                component: AddNumTelegram,
                name: 'AddNumTelegram',
                meta:{
                    isJudge:true
                }
            },
            {
                path: '/viewPort/AddCard',
                component: AddCard,
                name: 'AddCard',
                meta:{
                    isJudge:true
                }
            },
        ]
    },
    {
        path: '*',
        component: NotFound,
        name: 'NotFound'
    },
]